// frontend/src/config/api/endpoints/index.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Composição centralizada dos endpoints do frontend.
 */

import {
  agentsEndpoints,
  authEndpoints,
  projectsEndpoints,
  userEndpoints,
  webhooksEndpoints,
  whatsappEndpoints,
} from './coreEndpoints';
import {
  aiEngineEndpoints,
  assistantEndpoints,
  dynamicConfidenceEndpoints,
  escalationConfigEndpoints,
  escalationPredictionEndpoints,
  knowledgeEndpoints,
  llmProviderConfigEndpoints,
  llmProvidersEndpoints,
  operatorMatchingEndpoints,
  patternRecognitionEndpoints,
  personalityEndpoints,
  topicClassificationEndpoints,
} from './aiEndpoints';
import { erpEndpoints } from './erpEndpoints';
import { saudeEndpoints } from './saudeEndpoints';
import { superAdminEndpoints } from './superAdminEndpoints';

export const API_ENDPOINTS = {
  auth: authEndpoints,
  whatsapp: whatsappEndpoints,
  agents: agentsEndpoints,
  webhooks: webhooksEndpoints,
  projects: projectsEndpoints,
  user: userEndpoints,
  aiEngine: aiEngineEndpoints,
  assistant: assistantEndpoints,
  escalationConfig: escalationConfigEndpoints,
  escalationPrediction: escalationPredictionEndpoints,
  dynamicConfidence: dynamicConfidenceEndpoints,
  patternRecognition: patternRecognitionEndpoints,
  operatorMatching: operatorMatchingEndpoints,
  llmProviders: llmProvidersEndpoints,
  llmProviderConfig: llmProviderConfigEndpoints,
  topicClassification: topicClassificationEndpoints,
  knowledge: knowledgeEndpoints,
  personality: personalityEndpoints,
  superAdmin: superAdminEndpoints,
  saude: saudeEndpoints,
  erp: erpEndpoints,
};
